export default "__VITE_ASSET__DE3GP6un__"